import projection from '../generated/pwd210f1.json';
import { AcceptanceManifest } from '../types';
export const pwd210f1AcceptanceManifest = projection as AcceptanceManifest;
